import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatusForId } from '@ms/yammer-data-support';
import createCachedSelector from 're-reselect';

import type { CampaignOrganizers, User, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import { findUsers } from '../users/selectors';

type GetStatusForCampaignOrganizersId = (state: YammerState, campaignId: CampaignOrganizers['id']) => EntityStatus;
export const getStatusForCampaignOrganizersId: GetStatusForCampaignOrganizersId = (state, campaignId) =>
  getStatusForId(state.campaignOrganizers, campaignId);

export const findCampaignOrganizersById = createFindById('campaignOrganizers');
export const findCampaignOrganizersByIdThrows = createFindByIdThrows('campaignOrganizers');

type GetCampaignOrganizers = (state: YammerState, campaignId: CampaignOrganizers['id']) => User['id'][] | undefined;
export const getCampaignOrganizers: GetCampaignOrganizers = createCachedSelector(
  (_state: YammerState, campaignId: CampaignOrganizers['id']) => campaignId,
  findCampaignOrganizersById,
  (_campaignId, campaignOrganizers) => campaignOrganizers?.users.map((organizer) => organizer.nodeId)
)((_state, campaignId) => campaignId);

type GetCampaignOrganizersThrows = (state: YammerState, campaignId: CampaignOrganizers['id']) => User['id'][];
export const getCampaignOrganizersThrows: GetCampaignOrganizersThrows = createCachedSelector(
  (_state: YammerState, campaignId: CampaignOrganizers['id']) => campaignId,
  findCampaignOrganizersByIdThrows,
  (_campaignId, campaignOrganizers) => campaignOrganizers.users.map((organizer) => organizer.nodeId)
)((_state, campaignId) => campaignId);

type GetCampaignOrganizerUsersThrows = (state: YammerState, campaignId: CampaignOrganizers['id']) => User[];
/**
 * @deprecated This returns an array of entity objects and forces re-renders for the entire component tree when any
 * of the entities change. Consumers should select the list of userIds and pass each id to a child component which
 * can select the specific user fields it requires.
 */
export const getCampaignOrganizerUsersThrows: GetCampaignOrganizerUsersThrows = (state, campaignId) => {
  const userIds = getCampaignOrganizersThrows(state, campaignId);

  return findUsers(state, userIds);
};
